import React from 'react';
import PropTypes from 'prop-types';
import { STATUS_TONES } from '../../shared/utils/statusTones';
import styles from './statusFlag.module.scss';

// Jedinstven prikaz statusa / Da-Ne polja u tabelama i detaljima.
// Ton bira helper iz shared/utils/statusTones.js (pozitivno / negativno /
// neutralno), pa je isto pravilo boja svuda u sistemu.
const StatusFlag = ({
  tone = STATUS_TONES.neutral,
  children,
  title,
  multiline = false,
}) => (
  <span
    className={`${styles.flag} ${styles[tone] || styles.neutral} ${
      multiline ? styles.multiline : ''
    }`}
    title={title ?? (typeof children === 'string' ? children : undefined)}
  >
    {children}
  </span>
);

StatusFlag.propTypes = {
  tone: PropTypes.oneOf(Object.values(STATUS_TONES)),
  children: PropTypes.node,
  title: PropTypes.string,
  // Dozvoljava prelom reda (npr. "Poslata\nnotifikacija").
  multiline: PropTypes.bool,
};

export default StatusFlag;
